import React from 'react';
import PropTypes from 'prop-types';

import { CustomIcon } from '@p81-common/ui';
import {
  CompanyIcon,
  Heading,
  CompanyStatus,
  Text
} from 'components/common/Elements/Elements';
import CompanyList from './CompanyList/CompanyList';
import TenantDetails from '../../TenantDetails/TenantDetails';
import { useRightSideBar } from '@p81-common/ui';
import { links } from 'data/constants';
import classes from './CompanyHeader.module.scss';
import { access, hasAccess, resources } from 'utils/permissions';

const { salesforce } = links;

const CompanyHeader = ({ data, customerId, requestHeaderData }) => {
  const { setOpenSecondary, setComponentSecondaryDrawer } = useRightSideBar();
  const onClickTenantDetailsButton = () => {
    setOpenSecondary(true);

    setComponentSecondaryDrawer(
      <TenantDetails
        company={{
          companyName: data.name,
          tenantUUID: data.tenantUUID,
          tenantId: data.workspace.split('.')[0]
        }}
      />
    );
  };
  return (
    <>
      <div className={classes.company}>
        <CompanyIcon domain={data.info.site} />
        {data.salesforceAccountId !== '-' &&
        data.salesforceAccountId !== 'NA' ? (
          <a
            className={classes.link}
            href={`${salesforce}/Account/${data.salesforceAccountId}/view`}
            target="_blank"
            rel="noreferrer noopener"
          >
            <Heading size={1} className={classes.header}>
              {data.name}
            </Heading>
            <CustomIcon
              src={`${links.imagesBaseUrl}/logos/salesforce.svg`}
              className={classes.salesforce}
              color=""
              customSize={24}
            />
          </a>
        ) : (
          <Heading size={1} className={classes.header}>
            {data.name}
          </Heading>
        )}

        {data.status && data.status !== '-' && data.status !== 'NA' && (
          <CompanyStatus
            status={data.status}
            terminationStatus={data.terminationStatus}
            terminationStatusDate={data.terminationStatusDate}
            addStatus={data.poc}
          />
        )}
        {data.info.isCheckpointTenant && (
          <img
            width={16}
            height={16}
            src={`${links.imagesBaseUrl}/icons2/icon_checkPoint.svg`}
            alt="checkpoint tenant indicator"
            className={classes.checkpointIndicator}
            onClick={() => onClickTenantDetailsButton()}
          />
        )}
      </div>
      <Text size={4}>{data.workspace}</Text>
      {hasAccess([resources.CUSTOMERS, access.READ]) && (
        <CompanyList
          info={data.info}
          companyName={data.name}
          tenantId={data.workspace.split('.')[0]}
          customerId={customerId}
          requestHeaderData={requestHeaderData}
          tenantUUID={data.tenantUUID}
        />
      )}
    </>
  );
};

CompanyHeader.propTypes = {
  data: PropTypes.object,
  customerId: PropTypes.string.isRequired,
  requestHeaderData: PropTypes.func.isRequired
};

export default CompanyHeader;
